import initialState from './initialState'
import {FETCH_LUCKY_ALLOCATIONS, RECEIVE_LUCKY_ALLOCATIONS} from '../actions/actionTypes'

export default function luckyAllocations(state = initialState.luckyAllocations, action) {
	let newState
	switch (action.type) {
	case FETCH_LUCKY_ALLOCATIONS:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_LUCKY_ALLOCATIONS:
		newState = action.luckyAllocations
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}



// WEBPACK FOOTER //
// ./src/redux/reducers/luckyAllocations.js